import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import { ProductRecommendationCheckoutModel } from "@insite/client-framework/Services/ProductRecommendationsService";
import prepareTrack from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareTrack";
import {
    generateGeneralPrepare,
    mapCartLinesToItems,
} from "@insite/client-framework/Store/Components/ProductRecommendations/ProductRecommendationsSelector";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";

type HandlerType = Handler<{ cart: Cart }, { recommendation: ProductRecommendationCheckoutModel }>;

export const PrepareData: HandlerType = props => {
    const {
        getState,
        parameter: { cart },
    } = props;

    const state = getState();
    const session = getSession(state);
    const currency = session?.currency?.currencyCode || "";

    props.recommendation = {
        type: "checkout",
        checkout: {
            items: mapCartLinesToItems(state, cart.cartLines),
            shipping: cart.shippingAndHandling,
            total: cart.orderGrandTotal,
            subtotal: cart.orderSubTotal,
            currency,
        },
        ...generateGeneralPrepare(state),
    };
};

export const CallPrepareTrack: HandlerType = ({ dispatch, recommendation }) => {
    dispatch(prepareTrack({ prepareTrackData: recommendation }));
};

export const chain = [PrepareData, CallPrepareTrack];

const prepareCheckout = createHandlerChainRunner(chain, "PrepareCheckout");
export default prepareCheckout;
